import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';
import URLS from 'constants/urls';

const methods = {
  read: (httpClient, venueId) =>
    httpClient.get(URLS.venue.details(venueId)).then(({ data }) => transformKeysToCamelCase(data)),

  update: (httpClient, venueId, payload) => {
    const { scheduleUrl, ...rest } = payload;
    const data = transformKeysToSnakeCase({
      scheduleUrl: scheduleUrl || null, // ST-4056 - MSI 500s on an empty string
      ...rest,
    });
    return httpClient.patch(URLS.venue.details(venueId), data).then(() => methods.read(httpClient, venueId));
  },
};

const handler = ({ httpClient }, venueId, payload) => {
  if (venueId && payload) {
    return methods.update(httpClient, venueId, payload);
  }

  return methods.read(httpClient, venueId, payload);
};

export default makeEntityScaffold('SAGA.API.SAFETY', handler, { defaultKey: 1 });
